import GeneralLedgerAccount from '@/models/Accounting/GeneralLedgerAccounts/GeneralLedgerAccount';
import GeneralLedgerAccountState from "@/models/Accounting/GeneralLedgerAccounts/GeneralLedgerAccountState";

export default class UpdateGeneralLedgerAccountRequest extends GeneralLedgerAccount {
    public constructor(account: GeneralLedgerAccount, updatedAt: Date) {
        super();
        if (account) {
            this.name = account.name;
            this.code = +account.code;
            this.currency = account.currency;
            this.type = account.type;
        }
        this.state = GeneralLedgerAccountState.Active;
        this.updatedAt = updatedAt;
    }
}